import { NgModule } from '@angular/core';
import { QuotationToBookingMappingService } from "./quotation-to-booking-mapping.service";

@NgModule({
 imports: [],
 exports: [],
 declarations: [],
 providers: [QuotationToBookingMappingService],
})
export class QuotationToBookingMappingModule { }
